if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define(
    'cart-drawer-recommendations',
    class CartDrawerRecommendations extends HTMLElement {
      connectedCallback() {
        const container = this.querySelector('[data-url]');
        if (!container) return;

        fetch(container.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const recommendations = html.querySelector('#CartDrawerRecommendations');

            if (!recommendations || !recommendations.innerHTML.trim()) {
              this.remove();
              return;
            }

            container.innerHTML = recommendations.innerHTML;

            container.querySelectorAll('quick-add-modal').forEach((modal) => {
              document.body.appendChild(modal);
            });
          })
          .catch(() => this.remove());
      }
    }
  );
}